import React, { useRef, useEffect } from "react";
import Preloader from "../Preloader/Preloader";
import {
  getbookSameDayList,
  ResetbBookSameDataState,
} from "../../store/Slice/bookSameDaySlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getCleaningSameDayList,
  ResetCleaningSameDayDataState,
} from "../../store/Slice/cleaningSameDaySlice";
import { getResidenceTypeList } from "../../store/Slice/residenceTypeSlice";
import { ResetBookNowDetailState } from "../../store/Slice/bookNowDetailSlice";
import { getExtrasDetailList } from "../../store/Slice/extrasDetailSlice";
import { getCityListing } from "../../store/Slice/CityListingSlice";
import PaymentForm from "../Checkout/PaymentForm";
import { useLocation } from "react-router-dom";
import { getCustomerProfileById } from "../../store/Slice/customerProfileSlice";

const loadScript = (url, callback) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  script.onload = callback;

  document.head.appendChild(script);
};

const useClearSessionOnNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    const clearSessionData = () => {
      const sessionKeys = [
        "SameDayBookingId",
        "checkAvailabilityClick",
        "submitClick",
        "PayButtonClick",
        "bookNowButtonClick",
        "scheduledTime",
        "price",
        "EstimatedTime",
        "PricePerHour",
        "Tax",
        "FinalPrice",
        "CustomerName",
        "City",
        "selectedServiceName",
        "SelectedExtras",
        "CustomerEmail",
        "Bathroom",
        "FromTime",
        "CustomerPhone",
        "Date",
        "Residence",
        "ServiceId",
        "UntillTime",
        "Address",
        "Bedroom",
        "Unit",
      ];

      sessionKeys.forEach((key) => sessionStorage.removeItem(key));
    };

    clearSessionData();
  }, [location.pathname]);
};

const HomeContact = ({ labelDetailData, servicesDetailData }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const autocompleteRef = useRef(null);
  const autocomplete = useRef(null);

  const [fullName, setFullName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [firstFormShow, setFirstFormShow] = React.useState(false);
  const [secondFormShow, setSecondFormShow] = React.useState(false);

  const [bookNowDetailLoading, setBookNowDetailLoading] = React.useState(false);
  // const [continueLoading, setContinueLoading] = React.useState(false);

  const [address, setAddress] = React.useState("");
  const [residence, setResidence] = React.useState("");
  const [bedrooms, setBedrooms] = React.useState("");
  const [bathrooms, setBathrooms] = React.useState("");
  const [city, setCity] = React.useState("");
  const [selectedExtras, setSelectedExtras] = React.useState([]);
  const [date, setDate] = React.useState("");
  const [fromTime, setFromTime] = React.useState("");
  const [availableTimes, setAvailableTimes] = React.useState([]);
  const [untillTime, setUntillTime] = React.useState("");
  const [serviceId, setServiceId] = React.useState("");
  const [unit, setUnit] = React.useState("");

  const [fullNameError, setFullNameError] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const [addressError, setAddressError] = React.useState("");
  const [residencError, setResidenceError] = React.useState("");
  const [bedroomsError, setBedroomsError] = React.useState("");
  const [bathroomsError, setBathroomsError] = React.useState("");
  const [cityError, setCityError] = React.useState("");
  const [fromTimeError, setFromTimeError] = React.useState("");
  const [untillTimeError, setUntillTimeError] = React.useState("");
  const [dateError, setDateError] = React.useState("");
  const [serviceIdError, setServiceIdError] = React.useState("");
  const [unitError, setUnitError] = React.useState("");
  const [messageFormOneError, setMessageFormOneError] = React.useState("");
  const [messageFormTwoError, setMessageFormTwoError] = React.useState("");

  const [errorMessage, setErrorMessage] = React.useState(null);

  const dateInputRef = useRef(null);

  const submitClick = sessionStorage.getItem("submitClick");

  const checkAvailabilityClick = sessionStorage.getItem(
    "checkAvailabilityClick"
  );
  const isCustomerLoggedIn = sessionStorage.getItem("Customer-vUniqueCode");
  const bookNowButtonClick = sessionStorage.getItem("bookNowButtonClick");
  const customerName = sessionStorage.getItem("CustomerName");
  const userAddress = sessionStorage.getItem("Address");
  const selectedServiceName = sessionStorage.getItem("selectedServiceName");
  const SelectedExtras = sessionStorage.getItem("SelectedExtras");
  const ExtrasValue = SelectedExtras ? JSON.parse(SelectedExtras) : [];

  const extrasValue = ExtrasValue.join(", ");

  const fromTimeValue = sessionStorage.getItem("FromTime");

  const fromTimeNewValue = fromTimeValue
    ? fromTimeValue.replace(/^0/, "").replace(":00", "").toUpperCase()
    : "";

  const untillTimeValue = sessionStorage.getItem("UntillTime");

  const untillTimeNewValue = untillTimeValue
    ? untillTimeValue.replace(/^0/, "").replace(":00", "").toUpperCase()
    : "";

  const dateValue = sessionStorage.getItem("Date");

  let finalDateValue = "";
  if (dateValue) {
    const [year, month, day] = dateValue.split("-");

    // Always local (no UTC shift)
    const userSelectedDate = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    finalDateValue = `${userSelectedDate.toLocaleString("en-CA", {
      month: "long",
    })} ${day}`;
  }

  const CleningPrice = sessionStorage.getItem("price");
  const EstimatedTime = sessionStorage.getItem("EstimatedTime");
  const PricePerHour = sessionStorage.getItem("PricePerHour");
  const { bookSameDayData } = useSelector((state) => state.bookSameDayList);
  const { cleaningSameDayData } = useSelector(
    (state) => state.cleaningSameDayList
  );
  const { residenceTypeData } = useSelector((state) => state.residenceTypeList);
  const { cityListingData } = useSelector((state) => state.cityListing);
  const { bookNowDetailData } = useSelector((state) => state.bookNowDetailList);
  const { extrasDetailData } = useSelector((state) => state.extrasDetailList);

  const { customerProfileDetailData } = useSelector(
    (state) => state.customerProfileDetail
  );

  React.useEffect(() => {
    if (isCustomerLoggedIn) {
      dispatch(
        getCustomerProfileById({
          vUniqueCode: isCustomerLoggedIn,
        })
      );
    }
  }, [isCustomerLoggedIn, dispatch]);

  React.useEffect(() => {
    if (
      customerProfileDetailData &&
      customerProfileDetailData.code === 200 &&
      customerProfileDetailData?.data
    ) {
      setFullName(
        customerProfileDetailData?.data?.vFirstName +
          " " +
          customerProfileDetailData?.data?.vLastName || ""
      );
      setEmail(customerProfileDetailData?.data?.vEmail || "");
      setPhone(customerProfileDetailData?.data?.vMobile || "");
    }
  }, [customerProfileDetailData]);

  React.useEffect(() => {
    dispatch(getResidenceTypeList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getExtrasDetailList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getCityListing());
  }, [dispatch]);

  React.useEffect(() => {
    setFullName(sessionStorage.getItem("CustomerName") || "");
    setPhone(sessionStorage.getItem("CustomerPhone") || "");
    setEmail(sessionStorage.getItem("CustomerEmail") || "");
  }, []);

  const handleFullNameChange = (event) => {
    const fullNameValue = event.target.value;
    setFullName(fullNameValue);
    sessionStorage.setItem("CustomerName", fullNameValue);
    event.target.value.trim() !== "" && setFullNameError("");

    if (fullNameValue.trim() === "" && fullNameValue.length === 0) {
      setFullNameError("Full Name is Required.");
    } else {
      setFullNameError("");
    }
  };
  const handlePhoneChange = (event) => {
    const phoneValue = event.target.value.trim();
    if (!/^\d*$/.test(phoneValue)) {
      return;
    }
    setPhone(phoneValue);
    sessionStorage.setItem("CustomerPhone", phoneValue);
    event.target.value.trim() !== "" && setPhoneError("");
    if (phoneValue.trim() === "" && phoneValue.length === 0) {
      setPhoneError("Phone Number is Required.");
    } else if (+phoneValue.length === 10) {
      setPhoneError("");
    } else {
      setPhoneError("Invalid Phone Number.");
    }

    setMessageFormOneError("");
  };

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    setEmail(emailValue);
    sessionStorage.setItem("CustomerEmail", emailValue);
    event.target.value.trim() !== "" && setEmailError("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailValue === "" && emailValue.length === 0) {
      setEmailError("Email is Required.");
    } else if (!emailRegex.test(emailValue)) {
      setEmailError("Invalid Email Format.");
    } else {
      setEmailError("");
    }

    setMessageFormOneError("");
  };

  const ValidateSameDayForm = React.useCallback(() => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,12}$/;
    setFullNameError("");
    setPhoneError("");
    setEmailError("");

    if (fullName.trim() === "" && fullName.length === 0) {
      setFullNameError("Full Name is Required.");
      isValid = false;
    }

    if (phone.trim() === "") {
      setPhoneError("Phone Number is Required.");
      isValid = false;
    } else if (+phone.length === 10) {
      setPhoneError("");
    } else if (!phoneRegex.test(phone)) {
      setPhoneError("Invalid Phone Number.");
      isValid = false;
    }

    if (email === "" && email.length === 0) {
      setEmailError("Email is Required.");
      isValid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Invalid Email Format.");
      isValid = false;
    }

    return isValid;
  }, [fullName, phone, email]);

  const handleSameDayBookForm = React.useCallback(
    (e) => {
      e.preventDefault();

      // setFirstFormShow(false);

      const isValidForm = ValidateSameDayForm();
      if (isValidForm) {
        setLoading(true);
        dispatch(
          getbookSameDayList({
            vFullName: fullName,
            vEmail: email,
            vMobile: phone,
          })
        );
      }
    },
    [ValidateSameDayForm, fullName, email, phone, dispatch]
  );

  React.useEffect(() => {
    if (bookSameDayData && bookSameDayData.code === 200) {
      setLoading(true);

      setTimeout(() => {
        // setFullName("");
        // setEmail("");
        // setPhone("");
        setLoading(false);

        setMessageFormOneError("");

        setFirstFormShow(false);
        // setSubmitClick(true);
        sessionStorage.setItem("submitClick", true);
      }, 2000);
      sessionStorage.setItem(
        "SameDayBookingId",
        bookSameDayData && bookSameDayData.id
      );
      sessionStorage.setItem("CustomerName", fullName);
      dispatch(ResetbBookSameDataState());
    } else if (bookSameDayData && bookSameDayData.code === 404) {
      setLoading(false);
      setFirstFormShow(true);
      sessionStorage.setItem("submitClick", false);
      setMessageFormOneError(bookSameDayData.message);
      dispatch(ResetbBookSameDataState());
      // setLoading(true);

      // setTimeout(() => {
      //   // setFullName("");
      //   // setEmail("");
      //   // setPhone("");
      //   setMessageFormOneError("");
      //   // setLoading(false);
      // }, 2000);
    } else if (bookSameDayData && bookSameDayData.code === 400) {
      setLoading(false);
      sessionStorage.setItem("submitClick", false);
      setFirstFormShow(true);
      setMessageFormOneError(bookSameDayData.message);
      dispatch(ResetbBookSameDataState());
      // setLoading(true);

      // setTimeout(() => {
      //   // setFullName("");
      //   // setEmail("");
      //   // setPhone("");
      //   setMessageFormOneError("");
      //   // setLoading(false);
      // }, 2000);
    }
  }, [bookSameDayData, dispatch, fullName]);

  const updateStateFromSessionStorage = () => {
    setResidence(sessionStorage.getItem("Residence") || "");
    setServiceId(sessionStorage.getItem("ServiceId") || "");
    setBedrooms(sessionStorage.getItem("Bedroom") || "");
    setBathrooms(sessionStorage.getItem("Bathroom") || "");
    setCity(sessionStorage.getItem("City") || "");
    setAddress(sessionStorage.getItem("Address") || "");
    setDate(sessionStorage.getItem("Date") || "");
    setUnit(sessionStorage.getItem("Unit") || "");
    setFromTime(sessionStorage.getItem("FromTime") || "");
    setUntillTime(sessionStorage.getItem("UntillTime") || "");
    const storedExtras =
      JSON.parse(sessionStorage.getItem("SelectedExtras")) || [];
    setSelectedExtras(storedExtras);
  };

  React.useEffect(() => {
    updateStateFromSessionStorage();
  }, []);

  const handleDateChange = (event) => {
    const dateValue = event.target.value;
    setDate(dateValue);
    sessionStorage.setItem("Date", dateValue);

    if (!dateValue.trim()) {
      setDateError("Please select the date.");
    } else {
      setDateError("");
    }
  };

  const handleDateDivClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker(); // Open the date picker
    }
  };

  const handleResidence = (event) => {
    const residenceValue = event.target.value;
    setResidence(residenceValue);
    sessionStorage.setItem("Residence", residenceValue);

    if (residenceValue === "") {
      setResidenceError("Please select the type of residence.");
    } else {
      setResidenceError("");
    }
  };

  const handleBedrooms = (event) => {
    const bedroomsValue = +event.target.value;

    setBedrooms(bedroomsValue);
    sessionStorage.setItem("Bedroom", bedroomsValue);
    if (bedroomsValue === "") {
      setBedroomsError("Please select the total number of bedrooms.");
    } else {
      setBedroomsError("");
    }
  };
  const handleBathrooms = (event) => {
    const bathroomsValue = +event.target.value;
    setBathrooms(bathroomsValue);
    sessionStorage.setItem("Bathroom", bathroomsValue);
    if (bathroomsValue === "") {
      setBathroomsError("Please select the total number of bathrooms.");
    } else {
      setBathroomsError("");
    }
  };

  const handleCity = (event) => {
    const cityValue = event.target.value;
    setCity(cityValue);
    sessionStorage.setItem("City", cityValue);
    if (cityValue === "") {
      setCityError("Please select the city.");
    } else {
      setCityError("");
    }
  };

  const handleServiceChange = (event) => {
    const serviceIdValue = +event.target.value;
    setServiceId(serviceIdValue);
    sessionStorage.setItem("ServiceId", serviceIdValue);

    // Find the corresponding service name
    const selectedService = servicesDetailData?.data?.find(
      (service) => service.iServiceId === serviceIdValue
    );

    if (selectedService) {
      sessionStorage.setItem(
        "selectedServiceName",
        selectedService.vServiceName
      );
    }

    if (serviceIdValue === "") {
      setServiceIdError("Please select the service.");
    } else {
      setServiceIdError("");
    }
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedExtras;

    if (checked) {
      updatedExtras = [...selectedExtras, value];
    } else {
      updatedExtras = selectedExtras.filter((extra) => extra !== value);
    }

    setSelectedExtras(updatedExtras);
    sessionStorage.setItem("SelectedExtras", JSON.stringify(updatedExtras));
  };

  const handleFromTime = (event) => {
    const fromTimeValue = event.target.value;
    setFromTime(fromTimeValue);
    sessionStorage.setItem("FromTime", fromTimeValue);
    if (fromTimeValue === "") {
      setFromTimeError("Please Select a From time.");
    } else {
      setFromTimeError("");
    }
  };

  const handleUnitChange = (event) => {
    const unitValue = event.target.value;
    setUnit(unitValue);
    sessionStorage.setItem("Unit", unitValue);
    event.target.value.trim() !== "" && setUnitError("");
  };

  const generateAvailableTimes = (selectedDate) => {
    const now = new Date();
    const selected = new Date(selectedDate);

    let currentHour = now.getHours();
    let currentMinutes = now.getMinutes();

    const times = [
      "12:00AM",
      "1:00AM",
      "2:00AM",
      "3:00AM",
      "4:00AM",
      "5:00AM",
      "6:00AM",
      "7:00AM",
      "8:00AM",
      "9:00AM",
      "10:00AM",
      "11:00AM",
      "12:00PM",
      "01:00PM",
      "02:00PM",
      "03:00PM",
      "04:00PM",
      "05:00PM",
      "06:00PM",
      "07:00PM",
      "08:00PM",
      "09:00PM",
      "10:00PM",
      "11:00PM",
    ];

    let filteredTimes = times;

    // If the selected date is today, filter times after the current time
    if (
      selected.getFullYear() === now.getFullYear() &&
      selected.getMonth() === now.getMonth() &&
      selected.getDate() === now.getDate()
    ) {
      filteredTimes = times.filter((time) => {
        let [hour, minutes] = time.split(/[:\s]/);
        let modifier = time.includes("PM") ? "PM" : "AM";
        let parsedHour = parseInt(hour, 10);

        if (modifier === "PM" && parsedHour !== 12) parsedHour += 12;
        if (modifier === "AM" && parsedHour === 12) parsedHour = 0;

        return (
          parsedHour > currentHour ||
          (parsedHour === currentHour && parseInt(minutes) > currentMinutes)
        );
      });
    }

    setAvailableTimes(filteredTimes);
  };

  useEffect(() => {
    if (date) {
      generateAvailableTimes(date);
    }
  }, [date]);

  const handleUntillTime = (event) => {
    const untillTimeValue = event.target.value;
    setUntillTime(untillTimeValue);
    sessionStorage.setItem("UntillTime", untillTimeValue);

    const fromTime24 = convertTo24Hour(fromTime);
    const untillTime24 = convertTo24Hour(untillTimeValue);

    if (!untillTimeValue) {
      setUntillTimeError("Please select an Until time.");
    } else if (untillTime24 <= fromTime24) {
      setUntillTimeError("Until time must be greater than From time.");
    } else {
      setUntillTimeError("");
    }
  };

  const ValidateCheckAvailabilityForm = React.useCallback(() => {
    let isValid = true;

    const fromTime24 = convertTo24Hour(fromTime);
    const untillTime24 = convertTo24Hour(untillTime);

    setResidenceError("");
    setCityError("");
    setBedroomsError("");
    setBathroomsError("");
    // setSelectedExtrasError("");
    setAddressError("");
    setFromTimeError("");
    setUntillTimeError("");
    setDateError("");
    setUnitError("");

    if (address.trim() === "" && address.length === 0) {
      setAddressError("Full Address is Required.");
      isValid = false;
    } else if (address.length > 255) {
      setAddressError("Full Address cannot exceed 255 characters.");
      isValid = false;
    }
    if (residence === "") {
      setResidenceError("Please select the type of residence.");
      isValid = false;
    }
    if (serviceId === "") {
      setServiceIdError("Please select the service.");
      isValid = false;
    }
    if (city === "") {
      setCityError("Please select the city.");
      isValid = false;
    }
    if (bedrooms === "") {
      setBedroomsError("Please select the total number of bedrooms.");
      isValid = false;
    }
    if (bathrooms === "") {
      setBathroomsError("Please select the total number of bathrooms.");
      isValid = false;
    }

    if (fromTime === "") {
      setFromTimeError("Please Select a From time.");
      isValid = false;
    }

    // if (unit === "") {
    //   setUnitError("Unit/Apt is Required.");
    //   isValid = false;
    // }

    if (untillTime === "") {
      setUntillTimeError("Please Select an Until time.");
      isValid = false;
    } else if (untillTime24 <= fromTime24) {
      setUntillTimeError("Until time must be greater than From time.");
      isValid = false;
    }
    if (date.trim() === "" && date.length === 0) {
      setDateError("Please select the date.");
      isValid = false;
    }

    return isValid;
  }, [
    residence,
    serviceId,
    bedrooms,
    bathrooms,
    city,
    address,
    fromTime,
    untillTime,
    date,
  ]);

  const handleCheckAvailabilityForm = React.useCallback(
    (e) => {
      e.preventDefault();
      setSecondFormShow(false);

      const isValidForm = ValidateCheckAvailabilityForm();
      if (isValidForm) {
        dispatch(
          getCleaningSameDayList({
            data: {
              vResidence: residence,
              iServiceId: serviceId,
              iCityId: city,
              vBedrooms: bedrooms,
              vBathrooms: bathrooms,
              vExtras: selectedExtras.length > 0 ? selectedExtras : [],
              vUnit: unit,
              vAddress: address,
              vFrom: fromTime,
              vUntill: untillTime,
              vDate: date,
            },
            pathname: location.pathname,
          })
        );
      }
    },
    [
      ValidateCheckAvailabilityForm,
      dispatch,
      residence,
      serviceId,
      bedrooms,
      bathrooms,
      selectedExtras,
      city,
      address,
      fromTime,
      untillTime,
      date,
      unit,
      location.pathname,
    ]
  );

  React.useEffect(() => {
    if (cleaningSameDayData && cleaningSameDayData.code === 200) {
      setIsLoading(true);

      sessionStorage.setItem(
        "scheduledTime",
        cleaningSameDayData?.scheduled_time
      );

      sessionStorage.setItem("Tax", cleaningSameDayData?.tax);

      sessionStorage.setItem("price", cleaningSameDayData?.total_price);
      sessionStorage.setItem(
        "EstimatedTime",
        cleaningSameDayData?.estimated_time
      );
      sessionStorage.setItem(
        "PricePerHour",
        cleaningSameDayData?.price_per_hour
      );
      sessionStorage.setItem("FinalPrice", cleaningSameDayData?.final_price);

      setTimeout(() => {
        setResidence("");
        setBedrooms("");
        setServiceId("");
        setCity("");
        setBathrooms("");
        setSelectedExtras("");
        setAddress("");
        setFromTime("");
        setUntillTime("");
        setDate("");
        setUnit("");
        // setCheckAvailabilityClick(true);
        sessionStorage.setItem("checkAvailabilityClick", true);
        setIsLoading(false);
      }, 2000);
      dispatch(ResetCleaningSameDayDataState());
    } else if (cleaningSameDayData && cleaningSameDayData.code === 404) {
      sessionStorage.setItem("checkAvailabilityClick", false);
      setSecondFormShow(true);
      setMessageFormTwoError(cleaningSameDayData.message);
    } else if (cleaningSameDayData && cleaningSameDayData.code === 400) {
      sessionStorage.setItem("checkAvailabilityClick", false);
      setSecondFormShow(true);
      setMessageFormTwoError(cleaningSameDayData.message);
    }
  }, [cleaningSameDayData, dispatch]);

  const handleModifyClick = () => {
    setSecondFormShow(true);
    updateStateFromSessionStorage();
    sessionStorage.removeItem("checkAvailabilityClick");
  };

  const handleBackClick = () => {
    setLoading(false);
    setFirstFormShow(true);
    setTimeout(() => {
      sessionStorage.removeItem("submitClick");
      sessionStorage.removeItem("SameDayBookingId");
    }, 100);
  };

  const handleBookNowClick = React.useCallback((event) => {
    event.preventDefault();
    setBookNowDetailLoading(true);

    const timeoutId = setTimeout(() => {
      sessionStorage.setItem("bookNowButtonClick", "true");
      setBookNowDetailLoading(false);
    }, 2000);

    // Cleanup to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, []);

  React.useEffect(() => {
    if (
      bookNowDetailData &&
      bookNowDetailData.code === 200 &&
      sessionStorage.getItem("bookNowButtonClick") !== "true"
    ) {
      sessionStorage.setItem("bookNowButtonClick", "true");
      setBookNowDetailLoading(false);
      dispatch(ResetBookNowDetailState());
    } else if (bookNowDetailData && bookNowDetailData.code === 404) {
      setErrorMessage(bookNowDetailData.message);
      sessionStorage.setItem("bookNowButtonClick", "false");
      setBookNowDetailLoading(false);
    } else if (bookNowDetailData && bookNowDetailData.code === 400) {
      setErrorMessage(bookNowDetailData.message);
      setBookNowDetailLoading(false);
      sessionStorage.setItem("bookNowButtonClick", "false");
      setBookNowDetailLoading(false);
    }
  }, [bookNowDetailData, dispatch]);

  const closeIt = () => {
    setFirstFormShow(true);
    sessionStorage.removeItem("SameDayBookingId");
    sessionStorage.removeItem("checkAvailabilityClick");
    sessionStorage.removeItem("submitClick");
    sessionStorage.removeItem("PayButtonClick");
    sessionStorage.removeItem("bookNowButtonClick");
    sessionStorage.removeItem("scheduledTime");
    sessionStorage.removeItem("price");
    sessionStorage.removeItem("EstimatedTime");
    sessionStorage.removeItem("PricePerHour");
    sessionStorage.removeItem("Tax");
    sessionStorage.removeItem("FinalPrice");
    sessionStorage.removeItem("CustomerName");
    sessionStorage.removeItem("City");
    sessionStorage.removeItem("selectedServiceName");

    sessionStorage.removeItem("SelectedExtras");
    sessionStorage.removeItem("CustomerEmail");
    sessionStorage.removeItem("Bathroom");
    sessionStorage.removeItem("FromTime");
    sessionStorage.removeItem("CustomerPhone");
    sessionStorage.removeItem("Date");
    sessionStorage.removeItem("Residence");
    sessionStorage.removeItem("ServiceId");
    sessionStorage.removeItem("UntillTime");
    sessionStorage.removeItem("Address");
    sessionStorage.removeItem("Bedroom");
    sessionStorage.removeItem("Unit");
    sessionStorage.removeItem("discountedHomeTotalAmount");
  };

  window.onbeforeunload = closeIt;

  const convertTo24Hour = (time) => {
    let [hour, minute] = time.split(":");
    let modifier = time.includes("AM") ? "AM" : "PM";

    hour = parseInt(hour, 10);
    minute = parseInt(minute || "00", 10); // Handle cases without minutes

    if (modifier === "PM" && hour !== 12) {
      hour += 12;
    }
    if (modifier === "AM" && hour === 12) {
      hour = 0;
    }

    return hour * 60 + minute; // Convert time to total minutes for accurate comparison
  };

  React.useEffect(() => {
    const handlePlaceSelect = () => {
      const addressObject = autocomplete.current.getPlace();
      if (addressObject && addressObject.formatted_address) {
        const selectedAddress = addressObject.formatted_address;
        setAddress(selectedAddress);
        sessionStorage.setItem("Address", selectedAddress);
        setAddressError("");
      }
    };

    const handleScriptLoad = () => {
      if (
        window.google &&
        window.google.maps &&
        window.google.maps.places &&
        autocompleteRef.current
      ) {
        autocomplete.current = new window.google.maps.places.Autocomplete(
          autocompleteRef.current,
          {
            componentRestrictions: { country: "ca" }, // Restrict to Canada
          }
        );

        autocomplete.current.addListener("place_changed", handlePlaceSelect);
      }
    };

    if (!window.google || !window.google.maps || !window.google.maps.places) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=AIzaSyA5T2q_2XgLCc3vz-xzxekc2q5vO3NXvbQ&libraries=places`,
        handleScriptLoad
      );
    } else {
      handleScriptLoad();
    }

    if (city !== "" && autocompleteRef.current) {
      handleScriptLoad();
    }
  }, [city]);

  // React.useEffect(() => {
  //   dispatch(
  //     getLabelDetailList({
  //       vSlug: "home",
  //     })
  //   );
  // }, [dispatch]);

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const singleVisitHeading =
    labelMap.get("LBL_HOME_SINGLE_VISIT_SERVICE_HEADING") || "";
  const bookCleanerHeading =
    labelMap.get("LBL_HOME_BOOK_A_CLEANER_ON_YOUR_TIME_HEADING") || "";
  const sameDayCleanerHeading =
    labelMap.get("LBL_HOME_FIND_A_SAME_DAY_CLEANER_NOW_HEADING") || "";
  const privacyHeading =
    labelMap.get("LBL_HOME_WE_RESPECT_YOUR_PRIVACY_SUB_HEADING") || "";

  const fullNameText = labelMap.get("LBL_HOME_FULL_NAME_TEXT") || "";
  const emailAddressText = labelMap.get("LBL_HOME_EMAIL _ADDRESS_TEXT") || "";
  const phoneNumberText = labelMap.get("LBL_HOME_PHONE_NUMBER_TEXT") || "";

  const almostThereHeading =
    labelMap.get("LBL_HOME_ALMOST_THERE_HEADING") || "";
  const recidenceText = labelMap.get("LBL_HOME_TYPE_OF_RESIDENCE_TEXT") || "";
  const totalBedroomsText = labelMap.get("LBL_HOME_TOTAL_BEDROOMS_TEXT") || "";

  const totalBathroomsText =
    labelMap.get("LBL_HOME_TOTAL_BATHROOMS_TEXT") || "";
  const serviceText = labelMap.get("LBL_HOME_SERVICE_TEXT") || "";
  const extrasText = labelMap.get("LBL_HOME_EXTRAS_TEXT") || "";

  const aptUnitText = labelMap.get("LBL_HOME_APT_UNIT_TEXT") || "";
  const fullAddressText = labelMap.get("LBL_HOME_FULL_ADDRESS_TEXT") || "";

  const cityText = labelMap.get("LBL_HOME_CITY_TEXT") || "";
  const DateText = labelMap.get("LBL_HOME_DATE_TEXT") || "";
  const timeRangeText = labelMap.get("LBL_HOME_SELECT_TIME_RANGE_TEXT") || "";

  const fromText = labelMap.get("LBL_HOME_FROM_TEXT") || "";
  const untilText = labelMap.get("LBL_HOME_UNTIL_TEXT") || "";
  const longerTimeframeText =
    labelMap.get("LBL_HOME_THE_LONGER_TIMEFRAME_NOTE") || "";

  const successText = labelMap.get("LBL_HOME_SUCCESS_HEADING") || "";

  const successOneDesc =
    labelMap.get("LBL_HOME_SUCCESS_FIRST_DESCRIPTION") || "";
  const successTwoDesc =
    labelMap.get("LBL_HOME_SUCCESS_SECOND_DESCRIPTION") || "";
  const cleaningbookedText =
    labelMap.get("LBL_HOME_CLEANING_BOOKED_TEXT") || "";
  const addonsText = labelMap.get("LBL_HOME_ADD_ONS_TEXT") || "";

  const totalPriceText = labelMap.get("LBL_HOME_TOTAL_PRICE_TEXT") || "";

  return (
    <>
      {/* <Toast ref={toast} /> */}
      <section className="howitwork-section pt-100" id="bookingavailability">
        <div className="container">
          <div className="row pb-50">
            <div className="col-lg-12 text-center">
              <span className="small-title">{singleVisitHeading}</span>
              <h2 className="main-title mb-0">{bookCleanerHeading}</h2>
            </div>
          </div>
        </div>
      </section>
      {submitClick && firstFormShow === false ? (
        <>
          {isLoading ? (
            <section className="position-relative pb-100">
              <div className="container">
                <div className="row">
                  <div className="col-lg-7 col-md-10 mx-auto">
                    <div className="contactcard">
                      <Preloader />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <>
              {checkAvailabilityClick &&
              !isLoading &&
              secondFormShow === false ? (
                <>
                  {bookNowButtonClick && !bookNowDetailLoading ? (
                    <>
                      <section className="homecontact-section pb-100">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-7 col-md-10 mx-auto">
                              <div className="contactcard">
                                <PaymentForm
                                  firstFormShow={false}
                                  setFirstFormShow={setFirstFormShow}
                                  setFullName={setFullName}
                                  setEmail={setEmail}
                                  setPhone={setPhone}
                                  singleVisitHeading={singleVisitHeading}
                                  bookCleanerHeading={bookCleanerHeading}
                                  labelDetailData={labelDetailData}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </>
                  ) : (
                    <section className="homecontact-section pb-100">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-7 col-md-10 mx-auto">
                            <div className="contactcard">
                              <div className="getintouch-content text-center ps-0 pt-0">
                                <h2 className="main-title">{successText}</h2>
                                <p className="contactgray-para">
                                  {successOneDesc}{" "}
                                  <span>
                                    {fromTimeNewValue} and {untillTimeNewValue}
                                  </span>
                                  {successTwoDesc}
                                </p>
                                <div className="book-time-sort">
                                  <ul>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Your Cleaning can start between{" "}
                                          <span>
                                            {fromTimeNewValue} and{" "}
                                            {untillTimeNewValue}
                                          </span>{" "}
                                          on {finalDateValue}, at {userAddress}.
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          {cleaningbookedText}{" "}
                                          <span>{selectedServiceName}</span>
                                        </div>
                                      </div>
                                    </li>

                                    {extrasValue.length > 0 ? (
                                      <li>
                                        <div className="d-flex align-items-md-center">
                                          <div className="icon-list">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                            >
                                              <path
                                                d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                                fill="#FF6F00"
                                              />
                                              <path
                                                d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                                fill="#FF6F00"
                                              />
                                            </svg>
                                          </div>
                                          <div className="sort-list-desc">
                                            {addonsText}{" "}
                                            <span>{extrasValue}</span>
                                          </div>
                                        </div>
                                      </li>
                                    ) : (
                                      ""
                                    )}

                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Estimated Hours:{" "}
                                          <span>{EstimatedTime}</span>
                                        </div>
                                      </div>
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          Price Per Hour:{" "}
                                          <span>${PricePerHour}</span>
                                        </div>
                                      </div>
                                    </li>

                                    <li>
                                      <div className="d-flex align-items-md-center">
                                        <div className="icon-list">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                              fill="#FF6F00"
                                            />
                                            <path
                                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                              fill="#FF6F00"
                                            />
                                          </svg>
                                        </div>
                                        <div className="sort-list-desc">
                                          {totalPriceText}{" "}
                                          <span>${CleningPrice}</span>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                {errorMessage && (
                                  <div className="validation-error">
                                    {errorMessage}
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center",
                                  }}
                                >
                                  {bookNowDetailLoading ? (
                                    <>
                                      {" "}
                                      <button
                                        className="success-orangebtn"
                                        type="button"
                                        disabled
                                      >
                                        <span
                                          className="spinner-border spinner-border-sm me-1 custom-spinner"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Loading...
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleBookNowClick}
                                      >
                                        Book Now
                                      </button>
                                      {/* {isModalOpen && (
                                        <div className="modal-overlay">
                                          <div className="modal-content">
                                            <h7>
                                              Are you sure you want to proceed
                                              with the Book Now?
                                            </h7>
                                            <div className="modal-buttons">
                                              <button
                                                className="success-orangebtn"
                                                onClick={handleConfirmPayment}
                                              >
                                                Yes
                                              </button>
                                              <br />
                                              <button
                                                className="cancel-btn"
                                                onClick={() =>
                                                  setIsModalOpen(false)
                                                }
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      )} */}
                                    </>
                                  )}
                                  <button
                                    type="button"
                                    className="success-orangebtn success-bluebtn"
                                    onClick={handleModifyClick}
                                  >
                                    Modify
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
                </>
              ) : (
                <>
                  <section className="homecontact-section pb-100">
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="col-lg-10">
                          <div className="contactcard">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="getintouch-content p-0">
                                  <h2 className="main-title">
                                    {customerName} {almostThereHeading}
                                  </h2>
                                  <form className="login-form p-0">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {recidenceText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={residence}
                                            onChange={handleResidence}
                                          >
                                            <option value="">
                                              {`Select ${recidenceText || ""}`}
                                            </option>
                                            {residenceTypeData &&
                                              residenceTypeData.code === 200 &&
                                              residenceTypeData.data &&
                                              residenceTypeData.data.map(
                                                (type, typeIndex) => (
                                                  <option
                                                    key={typeIndex}
                                                    value={type.vResidenceType}
                                                  >
                                                    {type.vResidenceType}
                                                  </option>
                                                )
                                              )}
                                          </select>
                                          {residencError && (
                                            <div className="validation-error">
                                              {residencError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {totalBedroomsText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={bedrooms}
                                            onChange={handleBedrooms}
                                          >
                                            {" "}
                                            <option value="">
                                              {`Select ${
                                                totalBedroomsText || ""
                                              }`}{" "}
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                          </select>
                                          {bedroomsError && (
                                            <div className="validation-error">
                                              {bedroomsError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {`${totalBathroomsText}`}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={bathrooms}
                                            onChange={handleBathrooms}
                                          >
                                            <option value="">
                                              {totalBathroomsText}
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                          </select>
                                          {bathroomsError && (
                                            <div className="validation-error">
                                              {bathroomsError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {serviceText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={serviceId}
                                            onChange={handleServiceChange}
                                          >
                                            <option value="">
                                              {`Select ${serviceText || ""}`}
                                            </option>
                                            {servicesDetailData &&
                                            servicesDetailData.code === 200 &&
                                            servicesDetailData.data ? (
                                              servicesDetailData.data.map(
                                                (service, serviceIndex) => (
                                                  <option
                                                    value={service.iServiceId}
                                                    key={serviceIndex}
                                                  >
                                                    {service.vServiceName}
                                                  </option>
                                                )
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                          {serviceIdError && (
                                            <div className="validation-error">
                                              {serviceIdError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      <div className="col-lg-12">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputEmail1"
                                            className="form-label"
                                          >
                                            {extrasText}
                                          </label>
                                          <div className="contact-checkedDiv">
                                            {extrasDetailData &&
                                              extrasDetailData.code === 200 &&
                                              Array.isArray(
                                                extrasDetailData.data
                                              ) &&
                                              extrasDetailData.data.map(
                                                (extra, index) => (
                                                  <div
                                                    key={index}
                                                    className="form-check form-check-inline"
                                                  >
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={`inlineCheckbox${index}`}
                                                      value={extra.vExtras}
                                                      onChange={
                                                        handleCheckboxChange
                                                      }
                                                      checked={selectedExtras.includes(
                                                        extra.vExtras
                                                      )}
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor={`inlineCheckbox${index}`}
                                                    >
                                                      <img
                                                        width="17"
                                                        height="22"
                                                        src={extra.vImage}
                                                        alt={extra.vExtras}
                                                        // loading="lazy"
                                                      />{" "}
                                                      <span
                                                        style={{
                                                          marginLeft: "8px",
                                                        }}
                                                      >
                                                        {extra.vExtras}
                                                      </span>
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {cityText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={city}
                                            onChange={handleCity}
                                          >
                                            <option value="">
                                              {`Select ${cityText || ""}`}
                                            </option>

                                            {cityListingData &&
                                            cityListingData.code === 200 &&
                                            cityListingData.data ? (
                                              cityListingData.data
                                                .slice()
                                                .sort((a, b) =>
                                                  a.vCity.localeCompare(b.vCity)
                                                )
                                                .map((city, index) => (
                                                  <option
                                                    value={city.iCityId}
                                                    key={index}
                                                  >
                                                    {city.vCity}
                                                  </option>
                                                ))
                                            ) : (
                                              <></>
                                            )}
                                          </select>
                                          {cityError && (
                                            <div className="validation-error">
                                              {cityError}
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      {city.length > 0 ? (
                                        <>
                                          <div className="col-lg-6">
                                            <div className="login-inputDiv">
                                              <label
                                                htmlFor="exampleInputname"
                                                className="form-label"
                                              >
                                                {aptUnitText}
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="exampleInputphone"
                                                placeholder={`Enter ${
                                                  aptUnitText || ""
                                                }`}
                                                value={unit}
                                                onChange={handleUnitChange}
                                              />
                                              {unitError && (
                                                <div className="validation-error">
                                                  {unitError}
                                                </div>
                                              )}
                                            </div>
                                          </div>

                                          <div className="col-lg-6">
                                            <div className="login-inputDiv">
                                              <label
                                                htmlFor="exampleInputname"
                                                className="form-label"
                                              >
                                                {fullAddressText}
                                              </label>
                                              <input
                                                ref={autocompleteRef}
                                                type="text"
                                                className="form-control"
                                                placeholder={`Search ${fullAddressText}...`}
                                                value={address}
                                                onChange={(event) => {
                                                  setAddress(
                                                    event.target.value
                                                  );
                                                  sessionStorage.setItem(
                                                    "Address",
                                                    event.target.value
                                                  );
                                                }}
                                              />
                                              {addressError && (
                                                <div className="validation-error">
                                                  {addressError}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ) : null}
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="Date"
                                            className="form-label"
                                          >
                                            {DateText}
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            value={date}
                                            onClick={handleDateDivClick}
                                            onChange={handleDateChange}
                                            min={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            ref={dateInputRef}
                                          />
                                          {dateError && (
                                            <div className="validation-error">
                                              {dateError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-12">
                                        <p className="form-importantpara">
                                          {timeRangeText}
                                        </p>
                                      </div>

                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {fromText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={fromTime}
                                            onChange={handleFromTime}
                                          >
                                            <option value="">{fromText}</option>
                                            {availableTimes?.map(
                                              (time, index) => (
                                                <option
                                                  key={index}
                                                  value={time}
                                                >
                                                  {time}
                                                </option>
                                              )
                                            )}
                                          </select>
                                          {fromTimeError && (
                                            <div className="validation-error">
                                              {fromTimeError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-6 col-md-6">
                                        <div className="login-inputDiv">
                                          <label
                                            htmlFor="exampleInputname"
                                            className="form-label"
                                          >
                                            {untilText}
                                          </label>
                                          <select
                                            className="form-select"
                                            id="floatingSelectGrid"
                                            value={untillTime}
                                            onChange={handleUntillTime}
                                          >
                                            <option value="">
                                              {" "}
                                              {untilText}
                                            </option>

                                            {availableTimes
                                              .filter((item) => {
                                                const itemTime =
                                                  convertTo24Hour(item);
                                                const fromTime24 =
                                                  convertTo24Hour(fromTime);
                                                return (
                                                  itemTime > fromTime24 &&
                                                  itemTime <= 23 * 60
                                                ); // Convert 11 PM to minutes
                                              })
                                              .map((untime, unindex) => (
                                                <option
                                                  key={unindex}
                                                  value={untime}
                                                >
                                                  {untime}
                                                </option>
                                              ))}
                                          </select>
                                          {untillTimeError && (
                                            <div className="validation-error">
                                              {untillTimeError}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-12">
                                        <p className="contactgray-para">
                                          {longerTimeframeText}
                                        </p>
                                      </div>
                                      {messageFormTwoError && (
                                        <div className="validation-error">
                                          {messageFormTwoError}
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleCheckAvailabilityForm}
                                      >
                                        Check Availability
                                      </button>
                                      <button
                                        type="button"
                                        className="success-orangebtn success-bluebtn"
                                        onClick={handleBackClick}
                                      >
                                        Back
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <section
          className="homecontact-section pb-100"
          // ref={formRef}
          id="booking-form"
        >
          <div className="container">
            <div className="contactcard ">
              <div className="row">
                <div className="col-lg-6">
                  <img
                    className="contact-cardimg"
                    // width="4096"
                    // height="2731"
                    width="600"
                    height="540"
                    // src="/assets/images/contact-1.png"
                    // src="/assets/images/contact-1.webp"
                    src="/assets/images/contact-1-new.webp"
                    alt="Login"
                    loading="lazy"
                  />
                </div>
                <div className="col-lg-6">
                  <div className="getintouch-content">
                    <h2 className="main-title">{sameDayCleanerHeading}</h2>
                    <form
                      className="login-form p-0"
                      onSubmit={handleSameDayBookForm}
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputname"
                              className="form-label"
                            >
                              {fullNameText}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputname"
                              placeholder={`Enter ${fullNameText || ""}`}
                              value={fullName}
                              onChange={(event) => {
                                const value = event.target.value;
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  handleFullNameChange(event);
                                }
                              }}
                              maxLength="50"
                            />
                            {fullNameError && (
                              <div className="validation-error">
                                {fullNameError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label"
                            >
                              {emailAddressText}
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="exampleInputEmail1"
                              placeholder={`Enter ${emailAddressText || ""}`}
                              value={email}
                              onChange={handleEmailChange}
                            />
                            {emailError && (
                              <div className="validation-error">
                                {emailError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="login-inputDiv">
                            <label
                              htmlFor="exampleInputname"
                              className="form-label"
                            >
                              {phoneNumberText}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputphone"
                              placeholder={`Enter ${phoneNumberText || ""}`}
                              value={phone}
                              onChange={handlePhoneChange}
                              maxLength="10"
                            />
                            {phoneError && (
                              <div className="validation-error">
                                {phoneError}
                              </div>
                            )}
                          </div>
                        </div>

                        {messageFormOneError && (
                          <div className="validation-error">
                            {messageFormOneError}
                          </div>
                        )}
                      </div>
                      {loading ? (
                        <>
                          {" "}
                          <button
                            className="success-orangebtn"
                            type="button"
                            disabled
                          >
                            <span
                              className="spinner-border spinner-border-sm me-1 custom-spinner"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </button>
                        </>
                      ) : (
                        <button type="submit" className="success-orangebtn">
                          Continue
                        </button>
                      )}
                      <p className="contactgray-para mt-3">{privacyHeading}</p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export { HomeContact, useClearSessionOnNavigation };
